import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Checkbox from './base-checkbox';
import * as styles from '../../styles/checkbox';

// To use Pure Component
/* eslint-disable react/prefer-stateless-function */
import { jsx as ___EmotionJSX } from "@emotion/core";
class CheckboxWrapper extends React.PureComponent {
  render() {
    var checkboxWrapperFlags = {
      isFullWidth: this.props.appearance === 'full-width' || this.props.appearance === 'full-width-label-left',
      isLabelLeft: this.props.appearance === 'label-left' || this.props.appearance === 'full-width-label-left',
      isToggle: this.props.type === 'toggle',
      size: this.props.size === 'default' ? undefined : this.props.size,
      isTile: this.props.type === 'tile',
      isTileCheckbox: this.props.type === 'tile-checkbox'
    };
    var containerClass = classnames('domain-checkbox', {
      ["".concat(this.props.className)]: this.props.className,
      ["is-".concat(this.props.size)]: this.props.size !== 'default',
      'is-full-width': checkboxWrapperFlags.isFullWidth,
      'is-label-left': checkboxWrapperFlags.isLabelLeft,
      'is-toggle': checkboxWrapperFlags.isToggle,
      'is-tile': checkboxWrapperFlags.isTile,
      'is-tile-checkbox': checkboxWrapperFlags.isTileCheckbox
    });

    // Props built specifically to go into the input[type=checkbox]
    // This helps control what actually gets spread onto the input is valid
    var inputProps = {
      disabled: this.props.disabled,
      id: this.props.id,
      name: this.props.name,
      onBlur: this.props.onBlur,
      onChange: this.props.onChange,
      onFocus: this.props.onFocus,
      value: this.props.value
    };

    // Don't set props.checked unless it's passed as a prop or
    // it becomes a controlled component
    if (this.props.checked === undefined) {
      inputProps.defaultChecked = this.props.defaultChecked;
    } else {
      inputProps.checked = this.props.checked;
    }
    return (
      // disabling because I believe it's a false positive, Checkbox is getting the inputProps
      // eslint-disable-next-line jsx-a11y/label-has-for
      ___EmotionJSX("label", {
        htmlFor: inputProps.id,
        className: containerClass,
        css: styles.checkboxContainer(checkboxWrapperFlags)
      }, ___EmotionJSX(Checkbox, {
        inputRef: this.props.inputRef,
        checkboxWrapperFlags: checkboxWrapperFlags,
        inputProps: inputProps,
        size: this.props.size,
        type: this.props.type,
        indeterminate: this.props.indeterminate,
        labelContent: this.props.labelContent
      }), !checkboxWrapperFlags.isTile && !checkboxWrapperFlags.isTileCheckbox && ___EmotionJSX("div", {
        className: classnames('domain-checkbox__label', {
          'is-hidden': this.props.hideLabel
        }),
        css: styles.label(!!this.props.hideLabel)
      }, this.props.labelContent))
    );
  }
}
CheckboxWrapper.propTypes = {
  className: PropTypes.string,
  appearance: PropTypes.oneOf(['full-width', 'label-left', 'full-width-label-left', 'default']),
  type: PropTypes.oneOf(['checkbox', 'toggle', 'tile', 'tile-checkbox']),
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  indeterminate: PropTypes.bool,
  labelContent: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  size: PropTypes.string,
  value: PropTypes.string,
  hideLabel: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  PropTypes.shape({
    current: PropTypes.any
  })])
};
CheckboxWrapper.defaultProps = {
  className: undefined,
  appearance: 'default',
  type: 'checkbox',
  checked: undefined,
  defaultChecked: false,
  indeterminate: false,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  size: 'default',
  disabled: false,
  id: undefined,
  value: undefined,
  hideLabel: false,
  inputRef: undefined
};
export default CheckboxWrapper;